var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Reembolsos sem Nota para Pagamento")]),_c('div',{staticClass:"card-body"},[_c('b-tabs',[_c('NREmployeesAll')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }